import { render, staticRenderFns } from "./MetricsOverview.vue?vue&type=template&id=8263b532"
import script from "./MetricsOverview.vue?vue&type=script&lang=js"
export * from "./MetricsOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports